import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '@costar/theme-ui';

var _sm, _md, _lg, _xl, _xxl, _xl2, _xl3, _xl4, _xl5, _headings;
var baseFont = {
  fontFamily: 'heading',
  lineHeight: 'heading'
};
var headings = (_headings = {}, _defineProperty(_headings, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  variant: 'headings.xl'
})), _defineProperty(_headings, "sm", (_sm = {}, _defineProperty(_sm, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'sm',
  //16px
  fontWeight: 'bold'
})), _defineProperty(_sm, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'sm',
  //16px
  fontWeight: 'normal'
})), _defineProperty(_sm, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'sm',
  //16px
  fontWeight: 'light'
})), _sm)), _defineProperty(_headings, "md", (_md = {}, _defineProperty(_md, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'md',
  //18px
  fontWeight: 'bold'
})), _defineProperty(_md, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'md',
  //18px
  fontWeight: 'normal'
})), _defineProperty(_md, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'md',
  //18px
  fontWeight: 'light'
})), _md)), _defineProperty(_headings, "lg", (_lg = {}, _defineProperty(_lg, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'lg',
  //20px
  fontWeight: 'bold'
})), _defineProperty(_lg, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'lg',
  //20px
  fontWeight: 'normal'
})), _defineProperty(_lg, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'lg',
  //20px
  fontWeight: 'light'
})), _lg)), _defineProperty(_headings, "xl", (_xl = {}, _defineProperty(_xl, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl',
  //22px,
  fontWeight: 'bold'
})), _defineProperty(_xl, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl',
  //22px,
  fontWeight: 'normal'
})), _defineProperty(_xl, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl',
  //22px,
  fontWeight: 'light'
})), _xl)), _defineProperty(_headings, "xxl", (_xxl = {}, _defineProperty(_xxl, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xxl',
  //24px
  fontWeight: 'bold'
})), _defineProperty(_xxl, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xxl',
  //24px
  fontWeight: 'normal'
})), _defineProperty(_xxl, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xxl',
  //24px
  fontWeight: 'light'
})), _xxl)), _defineProperty(_headings, "xl2", (_xl2 = {}, _defineProperty(_xl2, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+2',
  //26px
  fontWeight: 'bold'
})), _defineProperty(_xl2, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+2',
  //26px
  fontWeight: 'normal'
})), _defineProperty(_xl2, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+2',
  //26px
  fontWeight: 'light'
})), _xl2)), _defineProperty(_headings, "xl3", (_xl3 = {}, _defineProperty(_xl3, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+3',
  //28px
  fontWeight: 'bold'
})), _defineProperty(_xl3, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+3',
  //28px
  fontWeight: 'normal'
})), _defineProperty(_xl3, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+3',
  //28px
  fontWeight: 'light'
})), _xl3)), _defineProperty(_headings, "xl4", (_xl4 = {}, _defineProperty(_xl4, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+4',
  //30px
  fontWeight: 'bold'
})), _defineProperty(_xl4, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+4',
  //30px
  fontWeight: 'normal'
})), _defineProperty(_xl4, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+4',
  //30px
  fontWeight: 'light'
})), _xl4)), _defineProperty(_headings, "xl6", (_xl5 = {}, _defineProperty(_xl5, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+6',
  //40px
  fontWeight: 'bold'
})), _defineProperty(_xl5, "normal", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+6',
  //40px
  fontWeight: 'normal'
})), _defineProperty(_xl5, "light", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontSize: 'xl+6',
  //40px
  fontWeight: 'light'
})), _xl5)), _defineProperty(_headings, '6xLarge', _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'normal',
  fontSize: 'xl+6' //40px
})), _defineProperty(_headings, '4xLarge', _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'bold',
  fontSize: 'xl+4' // 30px
})), _defineProperty(_headings, "large", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'normal',
  fontSize: 'xl+3' //28px
})), _defineProperty(_headings, '1xlarge', _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'bold',
  fontSize: 'xl+2' //26px
})), _defineProperty(_headings, '2xLarge', _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'bold',
  fontSize: 'xxl' //24px
})), _defineProperty(_headings, "medium", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'bold',
  fontSize: 'xl' //22px
})), _defineProperty(_headings, "mediumLight", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'light',
  fontSize: 'xl' //22px
})), _defineProperty(_headings, "small", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'bold',
  fontSize: 'md' //18px
})), _defineProperty(_headings, "xSmall", _objectSpread2(_objectSpread2({}, baseFont), {}, {
  fontWeight: 'bold',
  fontSize: 'sm' //16px
})), _headings);

export { baseFont, headings };
//# sourceMappingURL=headings.esm.js.map
